import React from 'react';

import { NumberVersion } from 'partials/Footer/styles';

export default function VersionNumber() {
  return <NumberVersion>3.3</NumberVersion>;
}
